import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { decodeToken } from '../../utils/jwtUtils';
import { selectAuthenticated } from '../sections/HomeSection/selectors';

import * as actions from './actions';

import { selectUnityAuthData } from '../../containers/App/selectors';
import { PATHS_CONST, PATHS_CONST_WITHOUT_COUNTRY } from './constants.js';

import { useLocation } from 'react-router-dom';

/**
 * Retrieve app sections when token changes effect
 *
 * @export
 */
export function useSectionsFetch(accessToken) {
  const dispatch = useDispatch();
  const authenticated = useSelector((state) => selectAuthenticated(state));
  const unityAuthData = useSelector((state) => selectUnityAuthData(state));

  React.useEffect(() => {
    if (accessToken && !authenticated) {
      dispatch(actions.loadAppSections(accessToken, unityAuthData));
    } else {
      const tokenData = accessToken.access_token
        ? decodeToken(accessToken.access_token)
        : {};
      const { profile } = tokenData;

      if (profile) {
        dispatch(actions.loadAppSections(accessToken, unityAuthData));
      }
    }
  }, [accessToken, dispatch]);
}

export const usePathsHok = (pathCountry) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    Object.values(PATHS_CONST_WITHOUT_COUNTRY).forEach((path) => {
      if (pathCountry === path)
        throw Error('Identical route to country: ' + pathCountry);
    });
    Object.values(PATHS_CONST).forEach((path) => {
      if (pathCountry === path)
        throw Error('Identical route to country: ' + pathCountry);
    });
    const pathsResult = {};
    Object.entries(PATHS_CONST).forEach(([key, path]) => {
      pathsResult[key] = pathCountry + path;
    });
    dispatch(actions.pathRoutesAdd(pathsResult));
  }, [pathCountry]);
};

function extractCountryCode(path) {
  const segments = path.split('/').filter(Boolean);
  if (segments.length > 0 && /^[a-zA-Z]{2}$/.test(segments[0])) {
    return segments[0];
  }
  return null;
}

export function useComscorePageView(clientId) {
  const location = useLocation();

  React.useEffect(() => {
    const country = extractCountryCode(location.pathname);
    console.log(
      'Inicializando Comscore',
      country,
      window._comscore,
      window.COMSCORE,
    );
    if (country) {
      if (!window._comscore) {
        window._comscore = window._comscore || [];
        window._comscore.push({
          c1: '2',
          c2: clientId,
          options: {
            enableFirstPartyCookie: true,
            bypassUserConsentRequirementFor1PCookie: true,
          },
        });

        const s = document.createElement('script');
        s.async = true;
        s.src =
          (document.location.protocol === 'https:'
            ? 'https://sb'
            : 'http://b') + `.scorecardresearch.com/cs/${clientId}/beacon.js`;
        document.body.appendChild(s);
      }

      if (window.COMSCORE && typeof window.COMSCORE.beacon === 'function') {
        window.COMSCORE.beacon({
          c1: '2',
          c2: clientId,
          options: {
            enableFirstPartyCookie: true,
            bypassUserConsentRequirementFor1PCookie: true,
          },
        });
      }
    }
  }, [location.pathname]);
}
